import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import HomeRoutes from './pages/HomeRoutes';

function App() {
  return (
    <>
      <HomeRoutes />
    </>
  );
}

export default App;
